import { PayPalButton } from "react-paypal-button-v2";
import AppContext from "../../../contexts/AppContext";
import React,{useContext} from 'react';

export function PayPalBtn(props) {
const contextType = useContext(AppContext);
const { amount, currency, createSubscription, onApprove, catchError,onError, onCancel,onInit,onClick} = props;
// const paypalKey = "AfgkbndTnh1W1v6nVjXyQblcg1on7HIO2jk51Azf0N1tro-1RaNYwkoZjqx_VDHAO-K3BUeODLTK0pHK"
const paypalKey = contextType.state.paypal_client_id;
return (
<PayPalButton
options={{
    clientId: paypalKey,
    intent:"subscription",
    vault:true
    }}
onInit={(data, details) => onInit(data, details)}
onClick={(data, details) => onClick(data, details)}
amount={amount}
currency={currency}
createSubscription={(data, details) => createSubscription(data, details)}
onApprove={(data, details) => onApprove(data, details)}
onError={(err) => onError(err)}
catchError={(err) => catchError(err)}
onCancel={(err) => onCancel(err)}
style={{
shape: 'rect',
color: 'blue',
layout: 'horizontal',
label: 'subscribe',
tagline:"false"
}}
/>
);
}
export default PayPalBtn;


// WEBPACK FOOTER //
// ./src/components/PayPal/subscription/PayPalBtn.js